import { z } from 'zod';
import { MediaDtoSchema } from '../media/media.schema';

export const CurrencyEnum = z.enum([
  'AED',
  'ALL',
  'AMD',
  'ARS',
  'AUD',
  'AZN',
  'BAM',
  'BDT',
  'BGN',
  'BHD',
  'BND',
  'BOB',
  'BRL',
  'BYN',
  'CAD',
  'CDF',
  'CHF',
  'CLP',
  'CNY',
  'COP',
  'CRC',
  'CZK',
  'DKK',
  'DOP',
  'EGP',
  'EUR',
  'GBP',
  'GEL',
  'GHS',
  'GTQ',
  'HKD',
  'HNL',
  'HRK',
  'HTG',
  'HUF',
  'IDR',
  'ILS',
  'INR',
  'IQD',
  'IRR',
  'ISK',
  'JPY',
  'KES',
  'KGS',
  'KHR',
  'KRW',
  'KWD',
  'KZT',
  'LAK',
  'LKR',
  'MAD',
  'MDL',
  'MKD',
  'MMK',
  'MNT',
  'MVR',
  'MXN',
  'MYR',
  'NGN',
  'NOK',
  'NPR',
  'NZD',
  'PAB',
  'PEN',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'RMB',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SEK',
  'SGD',
  'SLL',
  'SZL',
  'THB',
  'TJS',
  'TMT',
  'TND',
  'TRY',
  'TTD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'USD',
  'UYU',
  'UZS',
  'VND',
  'XAF',
  'XOF',
  'ZAR',
  'ZMW',
]);

export const BundleDtoPresentation = z.object({
  dailyBonusUpTo: z.number(),
  isVipBundle: z.boolean().optional(),
});

// Bundle DTO Schema
export const BundleDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  alias: z.string().optional(),
  priority: z.number(),
  goldCoins: z.number(),
  sweepCoins: z.number(),
  bonusSweepCoins: z.number(),
  price: z.number(),
  isSale: z.boolean(),
  salePrice: z.number().nullable(),
  cover: MediaDtoSchema,
  presentation: BundleDtoPresentation.nullable(),
  currency: CurrencyEnum,
  isActive: z.boolean(),
  // Product ids of the bundles grouped under this one as "show more" children.
  relatedProductIds: z.array(z.string()).optional(),
  isOneTimePurchase: z.boolean().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  updatedBy: z.string(),
});

export const OrderBundleDtoSchema = z.object({
  id: z.string().uuid(),
  goldCoins: z.number(),
  sweepCoins: z.number(),
  bonusSweepCoins: z.number().optional(),
  price: z.number(),
  isSale: z.boolean(),
  salePrice: z.number().nullable(),
  currency: CurrencyEnum,
});

export type BundleDto = z.infer<typeof BundleDtoSchema>;
export type OrderBundleDto = z.infer<typeof OrderBundleDtoSchema>;
